import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  Backdrop,
} from "@mui/material";
import { useTranslation } from "react-i18next";

function RequestApprovalModal({ open, onApprove, request, onReject }) {
  const { t } = useTranslation();

  console.log("Modal Request:", request);

  const message = `Do you want to approve this request to join the team of ${request?.[0]?.emplacementName} restaurant?`;

  return (
    <Backdrop
      open={open}
      sx={{
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        backdropFilter: "blur(8px)",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Dialog
        open={open}
        disableEscapeKeyDown
        hideBackdrop
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
          }
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
            border: "1px solid rgba(255, 255, 255, 0.1)",
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle
          sx={{
            pb: 1,
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          {t("Approval Request")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            sx={{
              py: 3,
              color: "text.primary",
            }}
          >
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            p: 2,
            pt: 0,
            gap: 2,
          }}
        >
          <Button
            onClick={() => onReject(request?.[0]?.id)}
            variant="outlined"
            color="inherit"
            sx={{ minWidth: 100 }}
          >
            {t("No")}
          </Button>
          <Button
            onClick={() => onApprove(request?.[0]?.id)}
            variant="contained"
            color="primary"
            autoFocus
            sx={{ minWidth: 100 }}
          >
            {t("Yes")}
          </Button>
        </DialogActions>
      </Dialog>
    </Backdrop>
  );
}

export default RequestApprovalModal;
